/**
 * Navigates the top-level window when embedded as an iframe, so the parent
 * page (not the iframe) lands on the destination. Falls back to in-iframe
 * navigation if cross-origin access to window.top is blocked.
 */
export function topNavigate(url: string): void {
  try {
    if (window.top && window.top !== window.self) {
      window.top.location.href = url;
      return;
    }
  } catch {
    // Cross-origin block — fall through to self navigation.
  }
  window.location.href = url;
}
